/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");


export default function downloadAsCSV(rows, filename, keys, header, formatter) {
  if (_.isNil(rows) || rows.length === 0) {
    return;
  }

  let csvContent = 'data:text/csv;charset=utf-8,\uFEFF';

  if (_.isArray(rows[0])) {
    rows.forEach((row, index) => {
      const line = row.join(',');
      csvContent += index < rows.length ? `${line}\n` : line;
    });
  } else {
    let ks = keys;
    if (_.isNil(ks)) {
      ks = _.uniq(_.flatMap(rows, _.keys));
    }
    // header
    if (header) {
      csvContent += `${_.map(ks, k => header[k]).join(',')}\n`;
    } else {
      csvContent += `${ks.join(',')}\n`;
    }
    rows.forEach((row, index) => {
      const line = _.map(ks, (k) => {
        const ky = k.split('.');
        let content;
        if (ky[1]) {
          content = (row[ky[0]] || {})[ky[1]];
        } else {
          content = row[k];
        }
        content = _.isNil(content) ? '' : content;
        if (formatter && formatter[ky]) {
          return formatter[ky](row);
        }
        return content;
      }).join(',');
      csvContent += index < rows.length ? `${line}\n` : line;
    });
  }

  if (window.Blob && window.navigator.msSaveOrOpenBlob) {
    const blobObject = new Blob([csvContent]);
    window.navigator.msSaveOrOpenBlob(blobObject, filename);
  } else {
    const link = document.createElement('a');
    const encodedUri = encodeURI(csvContent);
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
  }
}




// WEBPACK FOOTER //
// ./src/utils/csvdl.js